export default "__VITE_ASSET__DEvOH_57__"